// {
//   "id": 0,
//   "clave": "",
//   "origen_del_credito": 0,
//   "sistema": 0,
//   "tipo_de_credito": 0,
//   "numero_de_cuenta_del_credito": null,
//   "fecha_de_registro_del_credito": "2025-07-30T00:00:00Z",
//   "es_credito_externo": false,
//   "estado_del_credito": 0,
//   "observaciones_del_credito": null,
//   "ultima_ejecucion": 0,
//   "content_type_padron": 0,
//   "object_padron": 0,
//   "clave_del_padron": null,
//   "clave_principal_del_padron": null,
//   "clave_secundaria_del_padron": null,
//   "nombres_completos_del_padron": "",
//   "direccion_de_notificacion_del_padron": null,
//   "direccion_del_padron": null,
//   "codigo_postal_del_padron": null,
//   "correo_electronico_del_padron": null,
//   "celular_del_padron": null,
//   "datos_del_padron_json": {},
//   "observaciones_del_padron": null,
//   "estatus_del_padron": null,
//   "usar_contribuyente_del_padron": false,
//   "contribuyente": null,
//   "tipo_de_persona": null,
//   "nombre_completo_del_contribuyente": "",
//   "rfc_del_contribuyente": null,
//   "curp_del_contribuyente": null,
//   "nombre_comercial_del_contribuyente": null,
//   "nombre_del_contribuyente": null,
//   "apellido_paterno_del_contribuyente": null,
//   "apellido_materno_del_contribuyente": null,
//   "fecha_de_nacimiento_constitucion_del_contribuyente": null,
//   "direccion_de_notificacion_del_contribuyente": null,
//   "direccion_del_contribuyente": null,
//   "correo_electronico_del_contribuyente": null,
//   "celular_del_contribuyente": null,
//   "datos_del_contribuyente_json": {},
//   "observaciones_del_contribuyente": null,
//   "estatus_del_contribuyente": null,
//   "autoridad_determinante": 0,
//   "folio_de_documento_determinante": null,
//   "fecha_de_la_determinante": null,
//   "fecha_recepcion_de_la_determinante": null,
//   "fecha_de_obligacion_inicial_de_adeudos": null,
//   "total_determinante": 0.0,
//   "fecha_de_cancelacion": null,
//   "motivo_de_cancelacion": null,
//   "observaciones_de_cancelacion": null,
//   "usuario_de_cancelacion": null,
//   "usuario_creo": null,
//   "usuario_elimino": null,
//   "usuario_modifico": null,
//   "estado_global": 0,
//   "archivos_adjuntos": [],
//   "datos_del_credito_json": {}
// }
/* eslint-disable no-param-reassign */
import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import formatValues, { formatReceived } from 'utils/formatValues';
import { getContenTypePorTipoDePadron, getTipoDePadronPorContenType } from 'api/catalogos';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import addressToString from 'utils/address';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import Moment from 'moment';
import { MAPPERS, normalizeObject } from 'views/PAE/utils/mapping';
import { store } from 'store';

export const baseURI = 'recaudacion/creditos-pae/';

/**
 * GET Creditos
 * param {object} params
 * @returns {Promise<object>}
 */
export const getCreditos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });

    if (response?.data?.results) {
      const results = formatReceived(response.data.results).map((credito) => ({
        ...credito,
        tipo_de_padron: getTipoDePadronPorContenType(credito.content_type_padron),
      }));

      return {
        ...response.data,
        results,
      };
    }
    return response.data.map((credito) => ({
      ...credito,
      tipo_de_padron: getTipoDePadronPorContenType(credito.content_type_padron),
    })).sort((a, b) => a.orden_de_uso - b.orden_de_uso);
  } catch (err) {
    onError(err);
    return params?.page ? {
      results: [],
      count: 0,
      next: null,
      previous: null,
    } : [];
  }
};

const updateDatosDeCredito = async (id, values) => {
  try {
    // delete values.
    const response = await API.patch(`${baseURI}${id}`, {
      datos_de_credito_json: JSON.stringify(values),
    });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Credito
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCredito = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

const extractAdressData = (padron, key = 'direccion') => {
  const direccionObject = padron?.[key] || padron?.direccion_notificacion
  || padron?.direccion_index || padron?.direccion_notificacion_index;
  if (!direccionObject || !direccionObject?.id) return { id: null, direccion: null };

  const direccionString = addressToString(direccionObject);
  return {
    id: direccionObject.id,
    direccion: direccionString,
  };
};

/**
 * POST Credito
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCredito = async (values) => {
  try {
    const {
      direccion: direccion_del_padron,
      id: direccion_del_padron_id,
    } = extractAdressData(values.padron);

    const {
      direccion: direccion_de_notificacion_del_padron,
      id: direccion_de_notificacion_del_padron_id,
    } = extractAdressData(values.padron, 'direccion_notificacion_index');

    const {
      direccion: direccion_de_notificacion_del_contribuyente,
      id: direccion_de_notificacion_del_contribuyente_id,
    } = extractAdressData(values.contribuyente, 'direcciones_de_notificacion');

    const {
      id: direccion_del_contribuyente_id,
      direccion: direccion_del_contribuyente,
    } = extractAdressData(values.contribuyente);

    const normalizedContribuyente = normalizeObject(
      values.contribuyente,
      MAPPERS[padronesEnum.CONTRIBUYENTE],
    );

    const normalizedPadron = normalizeObject(
      values.padron,
      MAPPERS[values.tipo_de_padron],
    );

    const formatedValues = formatValues({
      ...values.credito,
      fecha_de_registro_del_credito: new Moment().format('YYYY-MM-DD HH:mm:ss'),
      direccion_de_notificacion_del_padron,
      direccion_de_notificacion_del_padron_id,
      direccion_de_notificacion_del_contribuyente,
      direccion_de_notificacion_del_contribuyente_id,
      direccion_del_contribuyente,
      direccion_del_contribuyente_id,
      direccion_del_padron,
      direccion_del_padron_id,
      object_id_padron: values.padron?.id,
      ...normalizedContribuyente,
      ...normalizedPadron,
    }, {
      clean: false,
    });

    formatedValues.content_type_padron = getContenTypePorTipoDePadron(values.tipo_de_padron);
    formatedValues.tipo_de_persona = store.getState()
      .catalogs.tiposDePersonas
      .find((e) => e.descripcion === values.contribuyente.tipo_de_persona)?.id;

    const response = await API.post(baseURI, {
      ...formatedValues,
      fecha_de_la_determinante: new Moment(formatedValues.fecha_de_la_determinante).format('YYYY-MM-DD HH:mm:ss'),
      fecha_de_obligacion_inicial_de_adeudos: new Moment(formatedValues.fecha_de_obligacion_inicial_de_adeudos).format('YYYY-MM-DD HH:mm:ss'),
      fecha_recepcion_de_la_determinante: new Moment(formatedValues.fecha_recepcion_de_la_determinante).format('YYYY-MM-DD HH:mm:ss'),
    });
    await updateDatosDeCredito(response.data.id, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Credito
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCredito = async (id, values) => {
  try {
    const formatedValues = formatValues(values, {
      clean: false,
    });
    formatedValues.content_type_padron = getContenTypePorTipoDePadron(values.tipo_de_padron);
    formatedValues.object_id_padron = values.padron_id;

    delete formatedValues.fecha_de_registro_del_credito;

    const response = await API.patch(`${baseURI}${id}`, {
      ...formatedValues,
      fecha_de_la_determinante: values?.credito?.fecha_de_la_determinante ?? new Moment().format('YYYY-MM-DD HH:mm:ss'),
      fecha_recepcion_de_la_determinante: values?.credito?.fecha_recepcion_de_la_determinante ?? new Moment().format('YYYY-MM-DD HH:mm:ss'),
      fecha_de_obligacion_inicial_de_adeudos: values?.credito?.fecha_de_obligacion_inicial_de_adeudos ?? new Moment().format('YYYY-MM-DD HH:mm:ss'),
      total_determinante: values?.credito?.total_determinante,
    });
    await updateDatosDeCredito(id, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Credito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCredito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
